

import { computed, defineComponent, onMounted, ref } from 'vue';
import { IapComponentDataSource } from '../../../../../component/domain/iapComponentDataSource';
import Dropdown from 'primevue/dropdown';

export default defineComponent({
    name: 'customdatasourcecontrol',
    components:{
        Dropdown
    },
    props: {
        data: Object
    },
    setup(props) {

        const selectedData = ref();

        const dataSources = computed(() => {
           
            if (props.data) {
                return props.data.dataSources as IapComponentDataSource[];                
            }
            return []
        })

        onMounted(() => {
            if (props.data) {
                selectedData.value = props.data.value
            }
        })

        return {
            selectedData,
            dataSources
        };
    },
});
